import { withErrorBoundary } from "@sentry/nextjs";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import styled from "styled-components";

interface Props {
  backgroundColor?: string;
  borderColor?: string;
  color?: string;
}

export const ToolTip = withErrorBoundary(
  ({ backgroundColor = "#292827;", borderColor = "#292827", color = "#fff" }: Props) => {
    const [mounted, setMounted] = useState(false);
    const [isMobileDevice, setIsMobileDevice] = useState(true);

    useEffect(() => {
      setMounted(true);

      setIsMobileDevice("ontouchstart" in window || navigator.maxTouchPoints > 0);
    }, []);

    return (
      <StyledTooltip $backgroundColor={backgroundColor} $borderColor={borderColor} $color={color}>
        {mounted ? (
          <Tooltip
            className="Tooltip"
            clickable
            globalCloseEvents={{ escape: true, resize: true, scroll: !!isMobileDevice }}
            id="tooltip"
            place="bottom"
          />
        ) : null}
      </StyledTooltip>
    );
  },
  {}
);

interface StyledProps {
  $backgroundColor: string;
  $borderColor: string;
  $color: string;
}

const StyledTooltip = styled.div<StyledProps>`
  position: relative;

  .react-tooltip__show {
    opacity: 1;
  }

  .__react_component_tooltip.place-bottom::before {
    border-left: none;
    border-right: none;
  }

  .Tooltip {
    background-color: ${({ $backgroundColor }) => $backgroundColor} !important;
    overflow-wrap: break-word;
    width: 260px;
    padding: 10px 12px;
    border-color: ${({ $borderColor }) => $borderColor};
    border-radius: 8px;
    color: ${({ $color }) => $color};
    font-size: 14px;
    font-weight: 450;
    line-height: 20px;

    ul {
      padding-left: 18px;

      li {
        margin-left: 3px;
      }
    }

    &.__react_component_tooltip.place-left::after {
      border-left-color: ${({ $backgroundColor }) => $backgroundColor} !important;
    }

    &.__react_component_tooltip.place-right::after {
      border-right-color: ${({ $backgroundColor }) => $backgroundColor} !important;
    }

    &.__react_component_tooltip.place-top::after {
      border-top-color: ${({ $backgroundColor }) => $backgroundColor} !important;
    }

    &.__react_component_tooltip.place-bottom::after {
      border-bottom-color: ${({ $backgroundColor }) => $backgroundColor} !important;
    }

    a {
      text-decoration: underline;
    }
  }
`;
